import { render, staticRenderFns } from "./CNICPromoSuggestions.vue?vue&type=template&id=13378724"
import script from "./CNICPromoSuggestions.vue?vue&type=script&lang=js"
export * from "./CNICPromoSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports